﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global, isEmpty } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import * as moment from '../../node_modules/moment/moment';
import { SaopRegUraDogodekView } from "./saop-regUraDogodek-view";
import { SaopRegCurrentEventView } from './saop-regCurrentEvent-view'

export class SaopRegTodayEventsView extends SaopRegUraDogodekView {
    public regCurrentEventView:SaopRegCurrentEventView;
    //
    private _saopServicesCore :SaopServicesCore;
    private saldoUreTekoceHHMM_ms = 0;

    constructor(viewId:string,libName:string = "") {
        super(viewId,libName);
        this._saopServicesCore = new SaopServicesCore();
        //
        this.refreshData = this.refreshListData.bind(this);
        //
        this.regCurrentEventView = new SaopRegCurrentEventView("#regAcctionButtonsView",libName+".regCurrentEventView");
        this.regCurrentEventView.afterSubmitSuccess = this.refreshListData.bind(this);   
    }

    initView(): void {
        global.ConsoleLogDegug("initView");
        this.initClock();
        this.onReadyInitRegUraDogodekView();
        this.onReadyInitDogodkiDanasnjiPartialView();        
    }

    bindGridEvents(){
        global.ConsoleLogDegug("bindGridEvents");
        let _this = this;
        //
        $("#regUraDogodekAddRecord").off("click");
        $("#regUraDogodekAddRecord").on('click', function(row){
            global.ConsoleLogDegug("regUraDogodekAddRecord.click");
            let currentDate = moment(new Date()).format("DD.MM.YYYY")
            _this.addRecord({ SelectedDay:currentDate});
        });         
        //
        $(".regDogodkiDanasnjiTable_edit").off("click");
        $(".regDogodkiDanasnjiTable_edit").on('click', function(row){
            global.ConsoleLogDegug("regDogodkiDanasnjiTable_edit.click");
            let _btnEdit = row.currentTarget;
            let btnEnabled = _btnEdit.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let zacetek = _btnEdit.getAttribute("data-zacetek");
                let konec = _btnEdit.getAttribute("data-konec");
                _this.editRecord({ idStart: zacetek, idEnd: konec },_this);
            }            
        });        
        //
        $(".regDogodkiDanasnjiTable_delete").off("click");
        $(".regDogodkiDanasnjiTable_delete").on('click', function(row){
            global.ConsoleLogDegug("regDogodkiDanasnjiTable_delete.click");
            let _btnDelete = row.currentTarget;
            let btnEnabled = _btnDelete.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let zacetek = _btnDelete.getAttribute("data-zacetek");
                let konec = _btnDelete.getAttribute("data-konec");
                // //
                let deleteModalFormTitle = _this.translationService.translate("Brisanje");
                let deleteModalFormBody = _this.translationService.translate("Ali ste prepričani, da želite izbrisati dogodek?");
                //
                _this.deleteRecord(deleteModalFormTitle,deleteModalFormBody,{ idStart: zacetek, idEnd: konec });
            }
        });         
    }

    afterRefreshData():void {
        global.ConsoleLogDegug("SaopRegTodayEventsView.afterRefreshListData");
    }

    refreshListData(trigger:boolean = true):void {
        global.ConsoleLogDegug("SaopRegTodayEventsView.refreshView");
        let _this = this;

        this._saopServicesCore.afterDone = function(response){
            $("#regTodayRecordForm").html(response);
            _this.bindGridEvents();
            _this.regCurrentEventView.bindFormAjaxEvents();   
        };
        this._saopServicesCore.ExecuteAction({
            action:"REGTodayEvents/MainFormPartial" 
            ,data:null
            ,type:"GET"
            ,spinnerDivId:"#regTodayRecordLoading"
        });       

        if (trigger && this.afterRefreshData != null){ this.afterRefreshData(); }
    }

    onReadyInitRegUraDogodekView(): void {
        global.ConsoleLogDegug("onReadyInitRegUraDogodekView");

        let message = <string>($("#OnLoadMessage").val());
        if (message) {
            alertify.message(message);
        }

        this.refreshListData();
    }

    initClock(): void {
        global.ConsoleLogDegug("onReadyInitDogodkiTekociPartialView");

        this.updateClock();
        this.updateClock1();
        this.updateClock2();
        this.updateClock3();

        setInterval(this.updateClock, 1000)
        setInterval(this.updateClock1, 1000)
        setInterval(this.updateClock2, 1000)
        setInterval(this.updateClock3, 1000)
    }

    updateClock(): void {
        let clockElement = $("#clock");

        // trenutni čas
        let currentTime = moment();
        let currentTime_ms = moment.duration(currentTime.format("HH:mm:ss")).asMilliseconds();

        // trenutni čas kot niz
        let currentTimeString = moment.utc(Math.abs(currentTime_ms)).format("HH:mm:ss");

        clockElement.html(currentTimeString);
    }

    updateClock1(): void {
        let clockElement1 = $("#clock1");

        // trenutni čas
        let currentTime = moment();
        let currentTime_ms = moment.duration(currentTime.format("HH:mm:ss")).asMilliseconds();

        //saldo vseh zaključenih dogodkov na dnevni ravni (stolpec "Dnevni saldo" v "Mesečni evidenci")
        let saldoUreHHMM = $('#SaldoUreHHMM').val() + ":00";
        let saldoUreHHMM_ms = moment.duration(saldoUreHHMM).asMilliseconds();

        //začetek zadnjega dogodka pred trenutnim časom
        let uraZadnjegaDogodka = $('#UraZadnjegaDogodka').val();

        //računanje tekoče dodanega časa
        let result_ms = saldoUreHHMM_ms;
        if (uraZadnjegaDogodka !== undefined) {
            let uraZadnjegaDogodka_ms = moment.duration(uraZadnjegaDogodka.toString()).asMilliseconds();

            if (uraZadnjegaDogodka_ms > 0)
                result_ms = result_ms + (currentTime_ms - uraZadnjegaDogodka_ms);
        }

        //ms -> formatted string
        let isNegative = result_ms < 0;
        let formattedDuration = moment.utc(Math.abs(result_ms)).format("H:mm");

        isNegative = isNegative && formattedDuration !== '0:00';
        const result = isNegative ? `-${formattedDuration}` : `+${formattedDuration}`;

        clockElement1.html(result);
    }

    updateClock2(): void {
        let clockElement2 = $("#clock2");

        // trenutni čas
        let currentTime = moment();
        let currentTime_ms = moment.duration(currentTime.format("HH:mm:ss")).asMilliseconds();

        //saldo vseh zaključenih dogodkov na dnevni ravni (stolpec "Tekoči saldo" v "Mesečni evidenci")
        let saldoUreTekoceHHMM = $('#SaldoUreTekoceHHMM').val() + ":00";
        let saldoUreTekoceHHMM_list = saldoUreTekoceHHMM.split(":");
        let saldoUreTekoceHHMM_ms = (Math.abs(Number(saldoUreTekoceHHMM_list[0]) * 3600) + Math.abs(Number(saldoUreTekoceHHMM_list[1]) * 60)) * 1000;
        saldoUreTekoceHHMM_ms = saldoUreTekoceHHMM_list[0][0] == '-' ? saldoUreTekoceHHMM_ms * (-1) : saldoUreTekoceHHMM_ms;
        this.saldoUreTekoceHHMM_ms = saldoUreTekoceHHMM_ms;

        //začetek zadnjega dogodka pred trenutnim časom
        let uraZadnjegaDogodka = $('#UraZadnjegaDogodka').val();

        //računanje tekoče dodanega časa
        let result_ms = saldoUreTekoceHHMM_ms;
        if (uraZadnjegaDogodka !== undefined) {
            let uraZadnjegaDogodka_ms = moment.duration(uraZadnjegaDogodka.toString()).asMilliseconds();

            if (uraZadnjegaDogodka_ms > 0)
                result_ms = result_ms + (currentTime_ms - uraZadnjegaDogodka_ms);
        }

        //ms -> formatted string (ne moremo uporabit enake funkcije kot v clock1, ker tudkaj lahko pride do ur večjih od 24)
        let isNegative = result_ms < 0;
        result_ms = Math.abs(result_ms);

        let hours = Math.floor(result_ms / 3600000);
        let minutes = Math.floor((result_ms - hours * 3600000) / 60000);

        let hoursStr = hours;
        let minutesStr = (minutes < 10 ? "0" : "") + minutes;

        let formattedDuration = hoursStr + ':' + minutesStr;
        isNegative = isNegative && formattedDuration !== '0:00';
        const result = isNegative ? `-${formattedDuration}` : `+${formattedDuration}`;

        clockElement2.html(result);
    }

    updateClock3(): void {
        let clockElement3 = $("#clock3");

        let naRazpolagoHHMM = $('#naRazpolagoHHMM').val() + ":00";
        let naRazpolagoHHMM_list = naRazpolagoHHMM.split(":");
        let naRazpolagoHHMM_ms = (Math.abs(Number(naRazpolagoHHMM_list[0]) * 3600) + Math.abs(Number(naRazpolagoHHMM_list[1]) * 60)) * 1000;
        naRazpolagoHHMM_ms = naRazpolagoHHMM_list[0][0] == '-' ? naRazpolagoHHMM_ms * (-1) : naRazpolagoHHMM_ms;

        let result_ms = naRazpolagoHHMM_ms + this.saldoUreTekoceHHMM_ms;
      
        let isNegative = result_ms < 0;
        result_ms = Math.abs(result_ms);

        let hours = Math.floor(result_ms / 3600000);
        let minutes = Math.floor((result_ms - hours * 3600000) / 60000);

        let hoursStr = hours;
        let minutesStr = (minutes < 10 ? "0" : "") + minutes;

        let formattedDuration = hoursStr + ':' + minutesStr;
        isNegative = isNegative && formattedDuration !== '0:00';
        const result = isNegative ? `-${formattedDuration}` : `+${formattedDuration}`;

        clockElement3.html(result);
    }

    onReadyInitDogodkiDanasnjiPartialView(): void {
        global.ConsoleLogDegug("onReadyInitDogodkiDanasnjiPartialView");

        $("#regDogodkiDanasnjiTable tbody tr").each(
            function (i, row) {
                // koda zakomentirana, ker ni potrebna.
                // Če ni zakomentirana, se pojavijo težave pri refresh view "Dogodki na dan", in se polje "Konec" obarva rdece zaradi spodnje kode

                //var $actualRow = $(row);

                //if ($actualRow.children('td:nth-child(2)').text() == "") {
                //    $(this).children('td:nth-child(6)').css("background-color", '#FAC0BE');
                //} else if ($actualRow.children('td:nth-child(1)').text() == "") {
                //    $(this).children('td:nth-child(5)').css("background-color", '#FAC0BE');
                //}
            });

        $("#webgrid1 th:nth-child(1)").hide();
        $("#webgrid1 th:nth-child(2)").hide();
    }

}


